import React from 'react'

import { Form, Col } from '_zari/core'

import { CodigosPermisos } from 'constants/index'

const PermisoFormGroup = ({ checked, onChange, val }) => {
  return (
    <Form.Group>
      <Col md={7}>
        <Form.Checkbox
          id={`checkbox-${val}`}
          name={`checkbox-${val}`}
          checked={checked}
          label={CodigosPermisos.__dictionary[val].nombre}
          value={val}
          onChange={onChange}
        />
      </Col>
    </Form.Group>
  )
}

export default PermisoFormGroup
